module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-backplates.af3fe60e.png";